import FHIRProxyClient from '../common/fhirproxy-client';

//TODO: Get the access token using a Client Credential oAuth flow with an APIClient App.
export const payerOrgId = 'HUMANA';
export const pwOrgId = 'PROJECTWELL';
export const humanaMemberId = '344364363456';
export const patientId = '1f763876-121e-4afa-8890-898fd472da76';
export const rdPractitionerId = '0d9f1663-e614-4348-9fc5-138583ee0a58';
export const oaPractitionerId = '1b3bada0-0018-4def-b328-56f0c0f743a2';
export const careTeamid = '15b71fd3-956d-43b9-bf7c-1f88542e8f23';
export const lastUpdatedBy = '';
export const planDefinitionId = 'humana-fi';
export const language = 'en-US';
// Blanked in the port. Upstream commits a real Cognito access token here, along with an internal
// admin address and the dev FHIR-proxy endpoint. The token is expired (2021-10-15) and its user
// pool no longer exists, so this is not a live credential — but the endpoint is current, and a
// checked-in bearer token is worth removing whatever its state.
//
// Nothing that runs loses anything. The five suites under this directory are the only readers of
// `accessToken`, `proxyURL`, `lastUpdatedBy` and `fhirProxyClient`, and vite.config.mts excludes
// `src/fhir-sdoh/test/**` from collection because they drive a live backend over the network. To
// run them, supply a token and the proxy URL locally rather than committing them again.
//
// The two production importers — AmazonConnectContext.tsx and ccp/dialpad.tsx — take only
// `payerOrgId`, and FHIRProxyClient's constructor just assigns its two fields, so constructing it
// from empty strings performs no request and changes no application behaviour.
export const accessToken = '';
export const proxyURL = '';
export const fhirProxyClient = new FHIRProxyClient(accessToken, proxyURL);
